webpackJsonp([80],{

/***/ 1074:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_permission_js__ = __webpack_require__(1308);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ece1d10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permission_vue__ = __webpack_require__(1511);
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_permission_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ece1d10_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Permission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1308:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_services__ = __webpack_require__(520);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      role_list: [],
      role_id: 99,
      menu_list: []
    };
  },
  created: function created() {
    this.checkOAuth();
  },

  methods: {
    callback: function callback(val) {
      console.log(val);
    },
    getRoleData: function getRoleData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__models_services__["a" /* default */].getRole(this.$store.state.URLHost, this.header, function (result) {
        if (result.response === true) {
          _this.role_list = result.data;
          _this.role_id = _this.role_list[0].r_id;
          _this.getMenu(_this.role_id);
        } else {
          _this.alert_msg('warning', 'Permission', result.message);
        }
      }, function (error) {
        _this.alert_msg('error', 'Permission', error.message);
        _this.required = true;
      });
    },
    getMenu: function getMenu(roleId) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__models_services__["a" /* default */].getPermission(this.$store.state.URLHost, roleId, this.header, function (result) {
        if (result.response === true) {
          _this2.menu_list = result.data;
          // eslint-disable-next-line no-undef
          $('.preloader').fadeOut();
        } else {
          _this2.alert_msg('warning', 'Permission', result.message);
          // eslint-disable-next-line no-undef
          $('.preloader').fadeOut();
        }
      }, function (error) {
        _this2.alert_msg('error', 'Permission', error.message);
        // eslint-disable-next-line no-undef
        $('.preloader').fadeOut();
        _this2.required = true;
      });
    },
    updatePermission: function updatePermission(roleId, menuId) {
      var _this3 = this;

      // eslint-disable-next-line no-undef
      $('.preloader').fadeIn();
      __WEBPACK_IMPORTED_MODULE_0__models_services__["a" /* default */].updateMenus(this.$store.state.URLHost, { role_id: roleId, menu_id: menuId }, this.header, function (result) {
        if (result.response === true) {
          _this3.alert_msg('success', 'Edit Permission', result.message);
          _this3.getMenu(roleId);
        } else {
          _this3.alert_msg('warning', 'Edit Permission', result.message);
        }
      }, function (error) {
        _this3.alert_msg('error', 'Edit Permission', error.message);
        _this3.required = true;
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    setTimeout(function () {
      _this4.getRoleData();
    }, 1000);
  }
});

/***/ }),

/***/ 1511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"d-lg-flex"},[_c('div',[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(_vm._s((_vm.$route.meta.title_sub) ? _vm.$route.meta.title_sub : _vm.$route.meta.title))]),_vm._v(" "),_c('h6',{staticClass:"card-subtitle"})])]),_vm._v(" "),_c('section',[_c('a-tabs',{style:({ height: _vm.$store.state.screenwidth + 'px'}),attrs:{"defaultActiveKey":_vm.role_id,"tabPosition":'top'},on:{"prevClick":_vm.callback,"nextClick":_vm.callback,"change":_vm.getMenu}},_vm._l((_vm.role_list),function(r){return _c('a-tab-pane',{key:r.r_id,attrs:{"tab":r.r_name}},[_c('a-row',{staticClass:"mb-2"},[_c('a-col',{attrs:{"span":24}},[_c('a-row',{staticStyle:{"border-bottom":"1px solid gray","padding-bottom":"10px"}},[_c('a-col',{staticStyle:{"text-align":"center","font-weight":"bold"},attrs:{"span":18}},[_vm._v("เมนู")]),_vm._v(" "),_c('a-col',{staticStyle:{"text-align":"center","font-weight":"bold"},attrs:{"span":4}},[_vm._v("สถานะ")])],1)],1)],1),_vm._v(" "),_c('a-row',[_c('a-col',{attrs:{"span":24}},_vm._l((_vm.menu_list),function(m,i){return _c('a-row',{key:'menu' + i,staticStyle:{"border-bottom":"1px dashed #cfcfcf"}},[_c('a-col',{staticClass:"p-2",attrs:{"span":18}},[_vm._v(_vm._s(i + 1)+". "+_vm._s(m.menu_name))]),_vm._v(" "),_c('a-col',{staticClass:"p-2",staticStyle:{"text-align":"center"},attrs:{"span":4}},[_c('a-switch',{attrs:{"checked":m.is_active === 1},on:{"change":function($event){return _vm.updatePermission(m.role_id, m.menu_id)}}})],1)],1)}),1)],1)],1)}),1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/80.56c585aba96f1cd4f91b.js